import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import JlProgressBar from 'jl-design-system/components/progress-bar/ProgressBar';

import { isNotEmpty } from '~/utils';
import { envConfigSelectors } from '~/components';
import { bookingsSelectors } from '~/api';

import styles from './ProgressBar.scss';

const mapProgressBarItemsToSteps = ({ progressBarItems, activePageIndex, history }) =>
  progressBarItems.map(({ label, props: extraProps }, stepIndex, items) => {
    const hasHref = !!extraProps && !!extraProps.href;
    const isPrev = stepIndex < activePageIndex;
    const { disableSiblings } = items[activePageIndex];
    const isClickable = hasHref && isPrev && !disableSiblings;

    return {
      label,
      tagName: isClickable ? 'a' : 'div',
      props: {
        className: classnames(styles.Step, {
          [styles.isDisabled]: !isClickable,
        }),
        onClick: isClickable ? () => history.pushWithToken(extraProps.href) : undefined,
      },
    };
  });

export const ProgressBar = ({ items = [], current, configLoaded, history }) => {
  if (!configLoaded) {
    return null;
  }
  const pageIndex = items.findIndex((item) => item.pattern.test(current));

  return (
    pageIndex !== -1 && (
      <JlProgressBar
        steps={mapProgressBarItemsToSteps({
          progressBarItems: items,
          activePageIndex: pageIndex,
          history,
        })}
        activeStep={pageIndex}
        className={classnames({
          [styles.ProgressBarShort]: items.length <= 2,
          [styles.ProgressBarMedium]: items.length >= 3 && items.length <= 4,
          [styles.ProgressBarContainer]: items.length >= 5,
        })}
      />
    )
  );
};

export const mapStateToProps = (state, ownProps) => {
  const {
    services: { config },
    editAppointment: { editMode },
    router: { location: routerLocation },
    appointment: {
      draft: {
        appointmentType: { id: draftAppointmentTypeId },
      },
    },
  } = state;
  const { location } = ownProps || {};
  const bookingAppointmentTypeId = bookingsSelectors.selectAppointmentTypeId(state);
  const appointmentTypeId = draftAppointmentTypeId || bookingAppointmentTypeId;
  return {
    configLoaded: isNotEmpty(config),
    items: editMode
      ? envConfigSelectors.editProgressBar(appointmentTypeId)(state)
      : envConfigSelectors.progressBar(appointmentTypeId)(state),
    current: location?.pathname || routerLocation.pathname,
  };
};

export const ConnectedProgressBar = withRouter(connect(mapStateToProps)(ProgressBar));

ProgressBar.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})),
  current: PropTypes.string.isRequired,
  configLoaded: PropTypes.bool.isRequired,
  history: PropTypes.shape({
    pushWithToken: PropTypes.func.isRequired,
  }).isRequired,
};
